const TYPE = 'REMOVE_DEVICE';

const action = (data) => (dispatch) => dispatch({ type: TYPE, payload: data });

export default { action, TYPE };
